import methods from '../methods'

const API_URL = '/api'

const getOccupations = () => methods.GET_API(`${API_URL}/occupations`)

export default {
  getOccupations
}
